<template>
  <v-row row wrap>

    <v-col cols="12">
      <v-row justify="space-between">
        <v-col cols="12" sm="6" md="8">
          <!-- FILTERS HERE -->
          <v-btn color="purple" dark :to="{name: 'AgenciaImportPage'}">IMPORTAR</v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <search-input @search="performSearch" v-model="search"/>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">

      <v-data-table
          class="mt-3"
          :headers="headers"
          :items="items"
          :search="search"
          :single-expand="false"
          :server-items-length="totalItems"
          :loading="loading"
          :page.sync="pageNumber"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="orderBy"
          :sort-desc.sync="orderDesc"
          :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
          @update:page="fetch"
          @update:sort-by="fetch"
          @update:sort-desc="fetch"
          @update:items-per-page="fetch"
      >

        <template v-slot:item.usuarios="{ item }">
          <v-list dense>
            <user-view v-for="user in item.usuarios" :key="user.id" :user="user"></user-view>
          </v-list>
        </template>

        <template v-slot:item.derivarDefault="{ item }">
          <div v-if="item.derivarDefault">
            <v-icon color="success">check_circle</v-icon>
          </div>
          <div v-else>
            <v-icon color="error">highlight_off</v-icon>
          </div>
        </template>

        <template slot="no-data">
          <div class="text-xs-center" v-t="'common.noData'"></div>
        </template>

        <template slot="loading">
          <div class="text-xs-center" v-t="'common.loading'"></div>
        </template>

        <template v-slot:item.action="{ item }">
          <show-button @click="$emit('show', item)"/>
          <edit-button v-if="$store.getters.hasPermission('AGENCIA_UPDATE')"  @click="$emit('update', item)" />
          <delete-button v-if="$store.getters.hasPermission('AGENCIA_DELETE')" @click="$emit('delete', item)" />
        </template>

      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import AgenciaProvider from "../../../../providers/AgenciaProvider";

import {DeleteButton, EditButton, ShowButton, SearchInput} from "@dracul/common-frontend"
import {UserView} from "@dracul/user-frontend"

export default {
  name: "AgenciaList",
  components: {DeleteButton, EditButton, ShowButton, SearchInput,UserView},
  data() {
    return {
      items: [],
      totalItems: null,
      loading: false,
      orderBy: null,
      orderDesc: false,
      itemsPerPage: 5,
      pageNumber: 1,
      search: '',
      filters: [
        /*{
            field: '',
            operator: 'eq', //(eq|contain|regex|gt|lt|lte|gte)
            value: ''
        }*/
      ]
    }
  },
  computed: {
    headers() {
      return [
        //Entity Headers
        {text: this.$t('cobrox.agencia.labels.nombre'), value: 'nombre'},
        {text: this.$t('cobrox.agencia.labels.derivarDefault'), value: 'derivarDefault'},
        {text: this.$t('cobrox.agencia.labels.telefonoDerivaciones'), value: 'telefonoDerivaciones'},
        {text: this.$t('cobrox.agencia.labels.telefonoConsultas'), value: 'telefonoConsultas'},
        {text: this.$t('cobrox.agencia.labels.mail'), value: 'mail'},
        {text: this.$t('cobrox.agencia.labels.horario_atencion'), value: 'horario_atencion'},
        {text: this.$t('cobrox.agencia.labels.observacion'), value: 'observacion'},
        {text: this.$t('cobrox.agencia.labels.usuarios'), value: 'usuarios'},
        //Actions
        {text: this.$t('common.actions'), value: 'action', sortable: false},
      ]
    },
    getOrderBy() {
      return (Array.isArray(this.orderBy)) ? this.orderBy[0] : this.orderBy
    },
    getOrderDesc() {
      return (Array.isArray(this.orderDesc)) ? this.orderDesc[0] : this.orderDesc
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    performSearch() {
      this.pageNumber = 1
      this.fetch()
    },
    fetch() {
      this.loading = true
      AgenciaProvider.paginateAgencia(
          this.pageNumber,
          this.itemsPerPage,
          this.search,
          this.filters,
          this.getOrderBy,
          this.getOrderDesc
      ).then(r => {
        this.items = r.data.paginateAgencia.items
        this.totalItems = r.data.paginateAgencia.totalItems
      }).catch(err => {
        console.error(err)
      }).finally(() => this.loading = false)
    }
  }

}
</script>


